import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Button } from './button.directive';
import { ButtonGroup } from './button-group.component';
import { Loading, LoadingModule } from '../loading/loading.module';

export { Button } from './button.directive';
export { ButtonGroup } from './button-group.component';
export { ButtonType } from './button-types';

@NgModule({
  declarations: [Button, ButtonGroup],
  exports: [Button, ButtonGroup],
  imports: [CommonModule, LoadingModule],
  entryComponents: [Loading],
})
export class ButtonModule { }
